import { InputWithLabel } from '@adotel/components'
import {
  Button,
  Modal,
  Paper,
  Slide,
  useMediaQuery,
  useTheme
} from '@material-ui/core'
import Typography from '@material-ui/core/Typography/Typography'
import EditIcon from '@material-ui/icons/Edit'
import SearchIcon from '@material-ui/icons/Search'
import { matchSorter } from 'match-sorter'
import { useEffect, useState } from 'react'

import { getDirection, getTranslate } from '../../localization'
import {
  RatePlanDeatials,
  RatePlanForPMSMappingList
} from '../../types/accommodationPMSMapping'
import RatePlansCodeMapingModalRow from './RatePlansCodeMapingModalRow'
import useStyles from './styles/RatePlansCodeMapingModal.styles'

interface RatePlansCodeMapingModalProps {
  isOpen: boolean
  onClose: () => void
  data: RatePlanForPMSMappingList[]
  setData: (data: RatePlanForPMSMappingList[]) => void
  onRatePlansChange: (
    AdotelCode: string,
    rateplans: RatePlanForPMSMappingList[],
    updatedRateplans: RatePlanDeatials[]
  ) => void
  adotelCodeForRoomtype: string
  changedData: RatePlanDeatials[]
  setChangedData: React.Dispatch<React.SetStateAction<RatePlanDeatials[]>>
  customizedForChannel?: boolean
}

const RatePlansCodeMapingModal: React.FC<RatePlansCodeMapingModalProps> = ({
  isOpen,
  onClose,
  data,
  setData,
  onRatePlansChange,
  adotelCodeForRoomtype,
  changedData,
  setChangedData,
  customizedForChannel
}) => {
  const classes = useStyles()
  const theme = useTheme()
  const [searchInput, setsearchInput] = useState<string>('')

  const filterRatePlans = (inputValue: string) => {
    const ans = matchSorter(data, inputValue, {
      keys: ['AdotelName', 'AdotelCode']
    })
    return ans
  }

  useEffect(() => {
    if (onRatePlansChange && changedData.length > 0) {
      onRatePlansChange(adotelCodeForRoomtype, data, changedData)
    }
  }, [changedData])

  const disabled = data.some(
    (item) =>
      item.PMSCode?.toLocaleLowerCase() === 'nodata' ||
      (!customizedForChannel && item.PMSCode === '')
  )

  return (
    <Modal
      open={isOpen}
      className={classes.modal}
      dir={getDirection()}
      onClose={onClose}>
      <Slide direction="down" in={isOpen}>
        <Paper className={classes.ratePlansPaper}>
          <EditIcon className={classes.editIcon} color="primary" />
          <div className={classes.title}>
            <Typography variant="h3">{getTranslate('RatePlans')}</Typography>
          </div>
          <div className={classes.inputWithLabel}>
            <InputWithLabel
              startIcon={<SearchIcon />}
              noHelperText
              placeholder={getTranslate('Search in RatePlans names & codes')}
              onChange={(event) => setsearchInput(event.currentTarget.value)}
            />
          </div>
          <div className={classes.tableHead}>
            <div>
              <Typography variant="body1">{getTranslate('Name')}</Typography>
            </div>
            {useMediaQuery(theme.breakpoints.up('sm')) && (
              <div>
                <Typography variant="body1">
                  {getTranslate('Adotel Code')}
                </Typography>
              </div>
            )}
            <div>
              <Typography variant="body1">
                {getTranslate('PMS Code')}
              </Typography>
            </div>
          </div>
          {filterRatePlans(searchInput).map((item, ratePlanIndex) => {
            return (
              <RatePlansCodeMapingModalRow
                key={ratePlanIndex}
                AdotelCode={item.AdotelCode}
                AdotelName={item.AdotelName}
                PMSCode={item.PMSCode || ''}
                disabled={!item.Active}
                onChange={(pmsCode) => {
                  const index = data.indexOf(item)
                  setData([
                    ...data.slice(0, index),
                    {
                      AdotelCode: item.AdotelCode,
                      AdotelName: item.AdotelName,
                      PMSCode: pmsCode,
                      Active: true
                    },
                    ...data.slice(index + 1)
                  ])
                  const singleChangeObj: RatePlanDeatials = {
                    AdotelCode: data[index].AdotelCode,
                    PMSCode: pmsCode
                  }
                  const existIndex = changedData.findIndex(
                    (ele) => ele.AdotelCode === data[index].AdotelCode
                  )
                  if (existIndex === -1) {
                    setChangedData([...changedData, singleChangeObj])
                  } else {
                    setChangedData((prevState) => {
                      const newState = [...prevState]
                      newState[existIndex] = singleChangeObj
                      return newState
                    })
                  }
                }}
                customizedForChannel={customizedForChannel}
              />
            )
          })}
          <div className={classes.buttonsStyles}>
            <Button variant="text" color="primary" onClick={onClose}>
              {getTranslate('Close')}
            </Button>
            <Button
              variant="contained"
              color="primary"
              className={classes.saveButton}
              disabled={disabled}
              onClick={() => {
                onClose()
              }}>
              {getTranslate('Save')}
            </Button>
          </div>
        </Paper>
      </Slide>
    </Modal>
  )
}
export default RatePlansCodeMapingModal
